import { useSelector }      from 'react-redux'; 
import CookieUtil           from "../utils/cookieUtil";
import _                    from 'lodash';

export const useTranslateText = (text: string, defaultText: string) => {
    const eventData = useSelector((state: any) => state.eventData); 
    return   translateText(text, defaultText, eventData);
    
};

const translateText = (text: string, defaultText: string = '', eventData: any) => {

    let selected_id = CookieUtil.readCookie('language_id');
    if (selected_id === undefined || selected_id === null) {
      selected_id = eventData.language[0]._id
    } 
    const translated_content = _.find(eventData.language, i => i.language_id._id === selected_id);
    if (!translated_content) {
      return defaultText;
    }
    let translateObj = translated_content.translates;

    const translated_text = _.has(translateObj, `${text}`) ? translateObj[`${text}`] : defaultText;
   if (translated_text) {
      return translated_text;
    } else {
      return text;
    }
};

